import { useNavigate } from "react-router-dom";
import "./AccountInactivePage.css";

export default function AccountInactivePage() {
    const navigate = useNavigate();

    return (
        <div className="account-inactive">
            <div className="account-inactive-card">
                <img
                    className="account-inactive-logo"
                    src={`${process.env.PUBLIC_URL}/logo.png`}
                    alt="Квокка"
                />
                <h1 className="account-inactive-title">Аккаунт не активен</h1>
                <p className="account-inactive-text">
                    Активируйте подписку, чтобы открыть кабинет. Доступ также мог быть ограничен, если найдено нарушение правил.
                </p>
                <button
                    type="button"
                    className="account-inactive-button"
                    onClick={() => navigate("/login", { replace: true })}
                >
                    На страницу входа
                </button>
            </div>
        </div>
    );
}
